import React from "react";
import Action from "../../components/Action";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";

import { BUYING_PROOF_OF_FUNDS_OPTIONS } from "../../constants";
import List, { ListItem } from "../../components/List";

const CheckHowIsBuyerPaying = ({
  howIsBuyerPaying,
  onlyMortgage,
  noSavings,
  noMortgage,
  onStepComplete,
  showPrevious,
}) => {
  const formatSourceOfFunds = (paying) => {
    if (!paying) return [];
    const payingName = Object.keys(paying).filter((key) => paying[key] === true);

    return payingName.map((name) => {
      const option = BUYING_PROOF_OF_FUNDS_OPTIONS.find((opt) => opt.name === name);
      return option.title;
    });
  };

  const handleContinue = () => {
    onStepComplete();
  };

  const fundingSources = formatSourceOfFunds(howIsBuyerPaying);

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Let’s quickly check your funds" removeTopPadding>
        <p id="funds-list">You’re using these funds to pay for your property:</p>
        <List bullet aria-labelledby="funds-list">
          {fundingSources.map((fundingSource, idx) => {
            return <ListItem key={idx}>{fundingSource}</ListItem>;
          })}
          {onlyMortgage && <ListItem>You’re only using a mortgage</ListItem>}
          {noSavings && <ListItem>You’re not using savings or investments</ListItem>}
          {noMortgage && <ListItem>You’re not taking out a mortgage on your new home</ListItem>}
        </List>

        {(onlyMortgage || noSavings) && (
          <>
            <p>People often use savings or investments as well as a mortgage - to pay for a deposit.</p>
            <p>
              If you’d like to add a savings account{!onlyMortgage && " or mortgage"}, choose “I’d like to add more
              funds” below.
            </p>
          </>
        )}

        {!noSavings && noMortgage && (
          <>
            <p>
              People often use a mortgage to pay for their property. If you’d like to add a mortgage, choose “I’d like
              to add more funds” below.
            </p>
          </>
        )}

        <Action onClick={handleContinue}>I’m only using the funds above - continue</Action>

        <Action onClick={showPrevious} secondaryButton={true}>
          I’d like to add more funds
        </Action>
      </Card>
    </React.Fragment>
  );
};

export default CheckHowIsBuyerPaying;
